import request from '@/utils/request'

// 查询区域列表分页
export function fetchList(query) {
    return request({
        url: '/upkeep/prod/page',
        method: 'get',
        params: query,
    })
}
// 查询区域列表不分页
export function prodList(query) {
    return request({
        url: '/upkeep/prod/list',
        method: 'get',
        params: query,
    })
}
// 查询区域详细
export function getObj(id) {
    return request({
        url: '/upkeep/prod/detail?id=' + id,
        method: 'get',
    })
}
// 新增区域
export function addObj(data) {
    return request({
        url: '/upkeep/prod/add',
        method: 'post',
        data: data,
    })
}

// 修改区域
export function putObj(data) {
    return request({
        url: '/upkeep/prod/edit',
        method: 'post',
        data: data,
    })
}
// 删除区域
export function delObj(data) {
    return request({
        url: '/upkeep/prod/delete',
        method: 'post',
        data: data,
    })
}
// 上下架区域
export function prodUnmount(data) {
    return request({
        url: '/upkeep/prod/status',
        method: 'post',
        data: data,
    })
}
// 增加库存
export function prodInventory(data) {
    return request({
        url: '/integral/prod/inventory',
        method: 'post',
        data: data,
    })
}
